import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Grid } from "@mui/material";
import { Box, Container, Typography, Paper, Divider, List, ListItem, ListItemText, Link, Button } from '@mui/material';
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../template/Footer";
import VerifiedIcon from '@mui/icons-material/VerifiedUser';
import "./About.css";

const Terms = ({loader}) => {

    const { authInstance } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const { authUser } = useContext(AuthContext);
    
    //console.log('authUser ', authUser);

    useEffect(() => {
        setLoaded(false);
        setError(null);
        setLoaded(true);
    },[authInstance, config.saas.permissions]);

    return (
        <>
            {loaded?(
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title="Terms" />

                    <Box className="about-hero">
                        <Container>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Typography variant="h2" className="hero-title">Terms of Service</Typography>
                                    <Typography variant="h6" color="text.secondary" className="hero-sub">
                                        Last updated: January 1, 2025
                                    </Typography>
                                    <Box sx={{ mt: 3 }}>
                                        <Button variant="outlined" color="secondary" onClick={() => navigate('/contact')}>Contact Us</Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Box className="hero-art">
                                        <VerifiedIcon sx={{ fontSize: 120, color: 'primary.main' }} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>

                    <Container sx={{ py: 6 }}>
                        <Paper elevation={3} sx={{ p: { xs:2, md:4 }, borderRadius: 3 }}>
                            <Typography variant="body1" paragraph>
                                These Terms of Service (“Terms”) govern your access to and use of our website,
                                applications, and services (collectively, the “Service”). By accessing or using
                                the Service, you agree to be bound by these Terms.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 3, mb: 1.5 }}>Overview</Typography>
                            <List dense>
                                <ListItem disableGutters>
                                    <ListItemText primary="1. Eligibility & Account Registration" />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemText primary="2. Acceptable Use" />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemText primary="3. Intellectual Property" />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemText primary="4. Third‑Party Services" />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemText primary="5. Disclaimers & Limitation of Liability" />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemText primary="6. Termination" />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemText primary="7. Changes to These Terms" />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemText primary="8. Contact Information" />
                                </ListItem>
                            </List>

                            <Divider sx={{ my: 3 }} />

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>1. Eligibility & Account Registration</Typography>
                            <Typography variant="body1" paragraph>
                                You must be at least 18 years old, or the age of majority in your jurisdiction,
                                to use the Service. When you create an account, you agree to provide accurate,
                                current, and complete information and to keep it updated.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>2. Acceptable Use</Typography>
                            <Typography variant="body1" paragraph>
                                You agree not to use the Service for any unlawful, harmful, or abusive purpose.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>3. Intellectual Property</Typography>
                            <Typography variant="body1" paragraph>
                                All content, features, and functionality of the Service, including text, graphics,
                                logos, and software, are owned by us or our licensors and are protected by
                                intellectual property laws.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>4. Third‑Party Services</Typography>
                            <Typography variant="body1" paragraph>
                                The Service may contain links to or integrations with third‑party websites,
                                products, or services. We do not endorse or assume responsibility for any
                                third‑party content or practices.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>5. Disclaimers & Limitation of Liability</Typography>
                            <Typography variant="body1" paragraph>
                                The Service is provided on an “as is” and “as available” basis, without warranties.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>6. Termination</Typography>
                            <Typography variant="body1" paragraph>
                                We may suspend or terminate your access to the Service at any time.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>7. Changes to These Terms</Typography>
                            <Typography variant="body1" paragraph>
                                We may update these Terms from time to time. When we do, we will revise the
                                “Last updated” date at the top of this page.
                            </Typography>

                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>8. Contact Information</Typography>
                                <Typography variant="body1" paragraph>
                                If you have any questions about these Terms, you can contact us at{' '}
                                <Link href="mailto:support@livingwaters.biz" color="secondary">support@livingwaters.biz</Link>.
                            </Typography>
                        </Paper>
                    </Container>

                    <Footer />
                </Container>
            ):(
                <>{loader}</>
            )}
        </>
    )
}

export default Terms;
